import React from 'react';
import { Trash2, Plus, Minus } from 'lucide-react';
import { formatCurrency } from '../../utils/formatCurrency';

const CartItem = ({ item, onUpdateQuantity, onRemove }) => {
  return (
    <div className="flex items-center space-x-4 py-4 border-b border-[#E8DFC8]">
      {/* Product Image */}
      <img
        src={item.image}
        alt={item.name}
        className="w-16 h-16 object-cover rounded-xl bg-[#F4EFE6] border border-[#E8DFC8] flex-shrink-0"
      />

      {/* Item Info */}
      <div className="flex-grow">
        <h4 className="text-xs font-serif font-bold text-[#4A0E17] line-clamp-1">
          {item.name}
        </h4>
        <p className="text-[11px] text-[#7A6B5D] mt-0.5">
          {formatCurrency(item.price)} each
        </p>

        {/* Selected Finish Color / Variant */}
        {item.selectedColor && (
          <div className="flex items-center space-x-1 mt-1">
            <span className="text-[10px] text-[#7A6B5D]">Color:</span>
            <span
              className="w-3 h-3 rounded-full border border-[#E8DFC8]"
              style={{ backgroundColor: typeof item.selectedColor === 'string' ? item.selectedColor : item.selectedColor?.hex || item.selectedColor?.name }}
            />
          </div>
        )}

        {/* Quantity Selector */}
        <div className="flex items-center space-x-2 mt-2">
          <button
            onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
            className="p-1 rounded-md bg-[#F4EFE6] border border-[#E8DFC8] hover:bg-[#4A0E17] hover:text-[#FDFBF7] text-[#4A0E17] transition-colors"
            aria-label="Decrease quantity"
          >
            <Minus className="w-3 h-3" />
          </button>
          <span className="text-xs font-bold text-[#4A0E17] px-1">{item.quantity}</span>
          <button
            onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
            className="p-1 rounded-md bg-[#F4EFE6] border border-[#E8DFC8] hover:bg-[#4A0E17] hover:text-[#FDFBF7] text-[#4A0E17] transition-colors"
            aria-label="Increase quantity"
          >
            <Plus className="w-3 h-3" />
          </button>
        </div>
      </div>

      {/* Price & Remove */}
      <div className="flex flex-col items-end justify-between self-stretch">
        <button
          onClick={() => onRemove(item.id)}
          className="text-[#7A6B5D] hover:text-[#8B1E2D] transition-colors"
          title="Remove item"
        >
          <Trash2 className="w-4 h-4" />
        </button>
        <span className="text-xs font-serif font-bold text-[#4A0E17]">
          {formatCurrency(item.price * item.quantity)}
        </span>
      </div>
    </div>
  );
};

export default CartItem;